import { RightTooltip } from 'ui/tooltip';
import { pluralResourcesText } from '../../utils';
import {
  SMS_SENDER_TERMS_BY_SENDING_PLATFORM,
  SMS_VERIFICATION_PROFILE_TERM,
  SendingPlatform,
  TELNYX,
  TWILIO,
  ITERABLE_SMS,
} from '../../constants';
import { useSendingPlatformsQueryContext } from '../../contexts';
import { IntegrationCard } from './IntegrationCard';
import { Ul } from './styled';

type SmsIntegrationCardProps = {
  sendingPlatform: SendingPlatform;
};

export const SmsIntegrationCard = ({ sendingPlatform }: SmsIntegrationCardProps) => {
  const { espAccountsBySendingPlatform, selectSmsSenders, selectVerificationProfilesByProvider } =
    useSendingPlatformsQueryContext();

  const espAccounts = espAccountsBySendingPlatform[sendingPlatform];
  const senders = espAccounts.map((espAccount) => selectSmsSenders(espAccount.id)).flat();
  const verificationProfiles = selectVerificationProfilesByProvider(sendingPlatform);

  const sendersText = pluralResourcesText(
    senders.length,
    SMS_SENDER_TERMS_BY_SENDING_PLATFORM[
      sendingPlatform as typeof TELNYX | typeof TWILIO | typeof ITERABLE_SMS
    ],
  );
  const verificationProfilesText = pluralResourcesText(
    verificationProfiles.length,
    SMS_VERIFICATION_PROFILE_TERM,
  );

  return (
    <IntegrationCard sendingPlatform={sendingPlatform}>
      <RightTooltip
        tooltipContent={
          senders.length > 0 && (
            <Ul>
              {senders.map(({ id: senderId, name: senderName }) => (
                <li key={senderId}>
                  <span>{senderName}</span>
                  <span>&nbsp;(ID {senderId})</span>
                </li>
              ))}
            </Ul>
          )
        }
        isEnabled={senders.length > 0}
        isUnderlined
      >
        {`${sendersText}, ${verificationProfilesText}`}
      </RightTooltip>
    </IntegrationCard>
  );
};
